export const IMAGES = {
    hero: "/images/hero.jpg",
};

export const REELS = {
    y2025: "9w3N6MATfzE",
    y2024: "Jral5SwYio0",
};

export const CONTACT_EMAIL = "contact@exodusfx.com";

export const SERVICES = [
    "ONSET VFX SUPERVISION",
    "IN-HOUSE VFX SUPERVISION",
    "COMPOSITING",
    "MATTE PAINTING",
    "SET EXTENSIONS",
    "ROTO & PAINT",
    "TRACKING",
    "CONCEPT DESIGN",
    "VFX CONSULTATION",
    "GAME DEVELOPMENT",
];

// fit: "cover" for cinematic stills, "contain" for poster art on a dark matte
export const PROJECTS = [
    {
        id: "wolves-always-come-at-night",
        title: "THE WOLVES ALWAYS COME AT NIGHT",
        meta: "AUSTRALIA'S OSCAR SUBMISSION 2026 - TIFF / LFF",
        status: "FESTIVAL RUN",
        image: "/images/wolves-poster.jpg",
        fit: "contain",
        span: "md:col-span-7",
        aspect: "aspect-[16/10]",
    },
    {
        id: "this-city-is-a-battlefield",
        title: "THIS CITY IS A BATTLEFIELD",
        meta: "10 NOMINATIONS INCL. BEST VFX",
        status: "COMPLETED",
        image: "/images/battlefield.jpg",
        fit: "cover",
        span: "md:col-span-5",
        aspect: "aspect-[16/10]",
    },
    {
        id: "p-valley",
        title: "P-VALLEY",
        meta: "STARZ / LIONSGATE EPISODIC",
        status: "COMPLETED",
        image: "/images/pvalley.jpg",
        fit: "contain",
        span: "md:col-span-4",
        aspect: "aspect-[3/4]",
    },
    {
        id: "perang-kota",
        title: "PERANG KOTA",
        meta: "CINESURYA PICTURES - FEATURE",
        status: "COMPLETED",
        image: "/images/perang-kota.jpg",
        fit: "contain",
        span: "md:col-span-4",
        aspect: "aspect-[3/4]",
    },
    {
        id: "exchange-fate",
        title: "EXCHANGE FATE",
        meta: "FEATURE - 2025",
        status: "COMPLETED",
        image: "/images/exchange-fate.jpg",
        fit: "contain",
        span: "md:col-span-4",
        aspect: "aspect-[3/4]",
    },
    {
        id: "if-i-had-legs",
        title: "IF I HAD LEGS, I'D KICK YOU",
        meta: "SUNDANCE 2025 - OFFICIAL SELECTION",
        status: "COMPLETED",
        image: "/images/hero.jpg",
        fit: "cover",
        span: "md:col-span-7",
        aspect: "aspect-[16/10]",
    },
];

export const SOFTWARE = [
    "NUKE",
    "FUSION",
    "RESOLVE",
    "BORISFX",
    "MOCHA",
    "ADOBE PS",
    "NEAT VIDEO",
    "TOPAZ AI",
    "EMBERGEN",
];
